import config from "../../../config/config";
import Axios from "axios";

const Sector_Url = config.baseUrl + "Sector";
const SubSector_Url = config.baseUrl + "subSector";
const Organization_Url = config.baseUrl + "organization";
const ActivityGroup_Url = config.baseUrl + "activityGroup";
const Product_Url = config.baseUrl + "product";
const Unit_Url = config.baseUrl + "unit";
const Layer_Url = config.baseUrl + "layer";
const Layer_Detail_Url = config.baseUrl + "layer/getLayers";
const Opp_Url = config.baseUrl + "oppurtunity";
const Province_Url = config.baseUrl + "province/";
const Potential_Url = config.baseUrl + "potential";
const Intersection_Url = config.baseUrl + "limitation/intersect";
const GeoApify = "https://api.geoapify.com/v1/geocode/reverse";
const SearchLog_Url = config.baseUrl + "oppurtunity/search/log";
const OppLog_Url = config.baseUrl + "oppurtunity/opp/log";
const SPECIFIED_QUESTIONS =
  config.baseUrl + "limitationQuestion/specifiedQuestion";
const GET_ALL_LIMITATION_CATEGORY = config.baseUrl + "limitationCategory";

export const getAllSector = () => {
  return Axios.get(Sector_Url);
};

export const getAllPotential = (params) => {
  return Axios.get(Potential_Url, {
    params,
  });
};

export const getIntersection = (data) => {
  return Axios.post(Intersection_Url, data);
};

export const getAllSubSector = (params) => {
  return Axios.get(SubSector_Url, {
    params,
  });
};

export const getAllOrganization = () => {
  return Axios.get(Organization_Url);
};

export const getAllActivityGroup = (params) => {
  return Axios.get(ActivityGroup_Url, {
    params,
  });
};

export const getAllProduct = (params) => {
  return Axios.get(Product_Url, {
    params,
  });
};

export const getAllUnit = (params) => {
  return Axios.get(Unit_Url, { params });
};

export const getAllLayer = (token) => {
  return Axios.get(Layer_Url, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getAllLayerDetail = (params) => {
  return Axios.get(Layer_Detail_Url, {
    params,
  });
};

export const getAllLimtationCategories = (params) => {
  return Axios.get(GET_ALL_LIMITATION_CATEGORY, {
    params,
  });
};

export const getAllOppurtunity = (params) => {
  return Axios.get(Opp_Url, {
    params,
  });
};

export const getProvince = (id) => {
  return Axios.get(Province_Url + id);
};

export const getGeoApifyDetails = (params) => {
  return Axios.get(GeoApify, {
    params,
  });
};

export const searchLog = (data) => {
  return Axios.post(SearchLog_Url, data);
};

export const oppLog = (data) => {
  return Axios.post(OppLog_Url, data);
};

export const getSpecifiedQuestions = (params) => {
  return Axios.get(SPECIFIED_QUESTIONS, { params });
};
